"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfMotorProgressBarSettings = void 0;
/**
 * This class is responsible for page progress bar configuration.
 *
 * It contains an array of pages where you want to display progress.
 * The sequence of items corresponds to the displayed progress.
 * The number of array elements is the total number of progress steps.
 */
var LvFlowProgressBarSettings_1 = require("./LvFlowProgressBarSettings");
var WolfMotorProgressBarSettings = /** @class */ (function (_super) {
    __extends(WolfMotorProgressBarSettings, _super);
    function WolfMotorProgressBarSettings() {
        var _this = _super.call(this) || this;
        /**
         * Order of the elements is important
         */
        _this.stepsToPageIdsMap = [
            ["numberPlateScan"],
            ["carDetails", "carDetailsEdit", "forcedCarDetailsEdit"],
            ["drivingLicenceScan"],
            ["otherDetails"],
            ["claimsPage"],
            ["ncd"],
            [
                "addDriver",
                "additionalDriverDrivingLicenceScanPage",
                "additionalDriverPersonalDetailsPage",
                "additionalDriverClaimsPage",
                "additionalDriverChangesStartDate",
                "addAdditionalDriverSummaryPage",
                "addAdditionalDriverPrice",
                "editAdditionalDriverClaimsPage",
                "editAdditionalDriverPersonalDetailsPage"
            ],
            ["additionalCarDetails"],
            ["coverOptions"],
            ["summary"],
            ["quoteSummary"],
            [_this.REGISTRATION_PAGE],
            [_this.REGISTRATION_CONFIRMATION_PAGE],
            [],
            ["paymentStart", "paymentNewCard", "paymentProcess", "paymentFailed", "paymentDirectDebit", "paymentNewCardDriverPolicyHolder", "paymentNewCardDriver"],
        ];
        _this.setKeycloakPageProgressCookies();
        return _this;
    }
    WolfMotorProgressBarSettings.prototype.getPercentageByPageId = function (pageId) {
        return _super.prototype.getPercentageInMapByPageId.call(this, this.stepsToPageIdsMap, pageId);
    };
    return WolfMotorProgressBarSettings;
}(LvFlowProgressBarSettings_1.LvFlowProgressBarSettings));
exports.WolfMotorProgressBarSettings = WolfMotorProgressBarSettings;
//# sourceMappingURL=WolfMotorProgressBarSettings.js.map